export const UPDATE_CREATE_PERMISSION = 'CreateVacancy';
export const TRANSFER_PERMISSION = 'MoveVacanciesBatch';
